import { isUnifiedPlan } from '../../sdpUtils/sdpSemantics'

/**
 * Replaces a specified transceiver's sender.track.
 * @method replaceTrack
 * @param {Object} newTrack The MediaStreamTrack we want to place into the sender.
 * @param {Object} options Options for specifying which transceiver's sender should be replaced. They are ordered by priority.
 * @param {Array} [options.trackId] The track id whose transceivers we want to set the direction of.
 * @return {Object} A Promise object which is fulfilled once the track has been replaced
 */
export default function replaceTrack (newTrack, options) {
  const { proxyPeer, config, log } = this
  log.info(`Replacing track ${options.trackId} with new ${newTrack.kind} track.`)

  return new Promise((resolve, reject) => {
    let sender
    if (isUnifiedPlan(config.rtcConfig.sdpSemantics)) {
      // Find the transceiver related to the provided track ID.
      const targetTransceiver = proxyPeer
        .getTransceivers()
        .find(transceiver => transceiver.sender.track && transceiver.sender.track.id === options.trackId)

      sender = targetTransceiver ? targetTransceiver.sender : undefined
    } else {
      sender = proxyPeer.getSenders().find(sender => sender.track.id === options.trackId)
    }

    if (sender) {
      sender
        .replaceTrack(newTrack)
        .then(resolve)
        .catch(error => {
          log.info(`Failed to replace track; ${error.message}`)
          reject(error)
        })
    } else {
      log.info(`Failed to replace track; could not find track ${options.trackId}.`)
      reject(new Error(`Sender for track ${options.trackId} not found.`))
    }
  })
}
